import { FC } from 'react';
import { useIntl } from 'react-intl';
import { PickingOrderLine } from '../models/PickingModels';

interface PickingLineRowProps {
  line: PickingOrderLine;
  isPicked: boolean;
  isLoading: boolean;
  onToggle: (lineId: number) => void;
}

const PickingLineRow: FC<PickingLineRowProps> = ({
  line,
  isPicked,
  isLoading,
  onToggle,
}) => {
  const intl = useIntl();
  const productName =
    line.product_name ||
    line.product_raw_name ||
    intl.formatMessage({ id: 'picking.unknownProduct' });

  return (
    <div
      className={`d-flex align-items-center justify-content-between p-3 mb-2 rounded border ${
        isPicked ? 'bg-light border-success' : 'bg-white border-secondary'
      }`}
      style={{ minHeight: 64 }}
    >
      <div className="d-flex flex-column flex-grow-1 me-3">
        <span className="fw-bold" style={{ fontSize: 16 }}>
          {productName}
        </span>
        {line.ean && (
          <span className="text-muted" style={{ fontSize: 12 }}>
            EAN: {line.ean}
          </span>
        )}
      </div>
      <div className="d-flex align-items-center gap-3">
        <span
          className="badge bg-primary rounded-pill"
          style={{ fontSize: 16, padding: '8px 16px' }}
        >
          x{line.quantity}
        </span>
        <button
          className={`btn btn-lg d-flex align-items-center justify-content-center ${isPicked ? 'btn-success' : 'btn-outline-success'}`}
          style={{
            width: 72,
            height: 72,
            fontSize: 28,
            borderRadius: 16,
            touchAction: 'manipulation',
          }}
          onClick={() => onToggle(line.id)}
          disabled={isLoading}
          aria-label={
            isPicked
              ? intl.formatMessage({ id: 'picking.unmarkAsPicked' })
              : intl.formatMessage({ id: 'picking.markAsPicked' })
          }
        >
          {isLoading ? (
            <span className="spinner-border spinner-border-sm" />
          ) : (
            '✓'
          )}
        </button>
      </div>
    </div>
  );
};

export { PickingLineRow };
